import { render } from "./ProductMinStockLvView.vue?vue&type=template&id=901a0866"
import script from "./ProductMinStockLvView.vue?vue&type=script&lang=js"
export * from "./ProductMinStockLvView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__